export default "__VITE_ASSET__BHNZAaNt__"